'use strict';

function trim(str) {
  return str.trim();
}

module.exports = trim;


// WEBPACK FOOTER //
// ./~/sugar-date/common/internal/trim.js